import { InputBaseStateType } from '@kubit/web-ui-components/inputBase/types';
import { commonStyles } from '../commonStyles';
import { InputBaseVariantType } from '../variants';
export const getInputBaseRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [InputBaseVariantType.REGULAR]: {
            ...commonStyles(FOUNDATIONS, {
                [InputBaseStateType.FOCUSED]: {},
                [InputBaseStateType.EMPTY]: {},
                [InputBaseStateType.FILLED]: {},
                [InputBaseStateType.ERROR_EMPTY]: {},
                [InputBaseStateType.ERROR_FILLED]: {},
                [InputBaseStateType.DISABLED_EMPTY]: {},
                [InputBaseStateType.DISABLED_FILLED]: {},
            }),
        },
    };
};
//# sourceMappingURL=regular.js.map